import React, { useState } from "react";
import {
  Button,
} from '../../ui-components';
import {
  FeatureTitle,
  Wrapper,
  Container,
} from './features.styled';
import Gallery from "../gallery/gallery";
import GalleryFullScreen from "../gallery/gallery-fullscreen"


const FeaturesFull = ({ gallery }) => {
  const [fullScreenIndex, setFullScreenIndex] = useState(null);
  const data = [
    {
      "type": "youtube",
      "youtube": "https://www.youtube.com/embed/iv7wCFpbXHA"
    }
  ]
  const fullScreenData = fullScreenIndex !== null ? data[fullScreenIndex] : null;

  const enterFullScreen = () => {
    setFullScreenIndex(0);
  }

  const handleClose = (event) => {
    event.preventDefault();
    setFullScreenIndex(null);
  }

  return (
    <>
      {fullScreenData
        ? (
          <GalleryFullScreen
            data={{
              type: fullScreenData.type,
              youtube: fullScreenData.youtube,
            }}
            disableNavigation
            onNext={() => { }}
            onPrev={() => { }}
            onClose={handleClose}
            forcedType="youtube"
          />
        )
        : ''}
      <Wrapper>
        <a name="product" />

        <Container>
          <FeatureTitle>Amphibious Camper-Trike</FeatureTitle>
        </Container>

        <Container center margin>
          <Button
            type="button"
            onClick={enterFullScreen}
            target="_blank"
            size="large"
            color="secondary"
          >
            Demo Video
          </Button>
          &nbsp;
          <Button
            type="anchor"
            to="/BeTRITON_Brochure_single.pdf"
            target="_blank"
            size="large"
            color="primary"
          >
            Brochure
          </Button>
        </Container>

        <Container>
          <Gallery data={gallery} />
        </Container>

      </Wrapper>
    </>
  )
}

export default FeaturesFull;
